/* tms-histoire.js — le bandeau « histoire » de la boutique (lot 09 comptes, D1 D2 D4 d'Alex).

   🔴 AUCUNE LECTURE DE PLUS À LA GALERIE. La famille de l'appareil est lue par le bandeau du lot 07, qui l'annonce
   (`tms:famille`) et garde la dernière annonce sur sa racine (`tmsDerniere`) : on l'écoute. Prête ⇒ l'aperçu de SA
   famille (la variante `data-gabarit`, sinon la première servie) remplace l'exemple ; une image en échec garde
   l'exemple. Le jeton ne part jamais dans une adresse.
   🔴 LA SESSION EST CELLE DE L'EN-TÊTE. tms-compte.js sonde une fois par page et l'annonce (`tms:session`, et
   `data-tms-session` sur <html> pour qui arrive après) : connecté ⇒ le chat tel quel (les cookies `tms_*` de l'envoi le
   connectent) ; anonyme ⇒ la page de connexion, `retour` = le chat. Avant la sonde, le lien va au chat : sans
   JavaScript ou sans sonde, le chat reste joignable.
   🔴 D4 : connecté ⇒ UN `GET /v1/families/me/choix` (lot 08) avec le cookie. `a_trancher` ⇒ les familles, « Keep this
   one » ⇒ UN `POST {id}` ; la choisie seule reste. Tout autre retour (une famille, 401, 404 d'une API d'avant le lot
   08, panne) ⇒ rien ne s'affiche : ce choix est une proposition, jamais une erreur montrée.
   🔴 (lot 10, R4) LE BOUTON ATTEND « PRÊTE ». `data-tms-histoire-etat` sur <html> (tms-histoire.css cache alors chaque
   lien) : « attente » tant que la famille annoncée est en cours (la phrase d'attente le remplace), retiré à « prête »
   comme à « échouée ». L'état « inconnu », posé par le snippet quand une famille est retenue, attend la première
   annonce au plus ATTENTE_MAX_MS : sans annonce (galerie injoignable), le bouton revient, jamais bloqué.
   ⚠️ Aucun texte n'est écrit ici : tout vient des `data-t-*` de la racine. */
(function () {
  "use strict";

  var racine = document.querySelector("[data-tms-histoire]");
  var liens = Array.prototype.slice.call(document.querySelectorAll("[data-tms-histoire-lien]"));
  if (!racine && !liens.length) return;
  var t = racine ? racine.dataset : {};
  var compte = document.querySelector("[data-tms-compte]");
  var bandeau = document.querySelector("[data-tms-bandeau]");
  var api = compte ? (compte.dataset.api || "").replace(/\/+$/, "") : "";
  var connexion = compte ? compte.dataset.connexion || "" : "";
  var service = bandeau ? (bandeau.dataset.service || "").replace(/\/+$/, "") : "";
  var MAX_PORTRAITS = 4;
  var ATTENTE_MAX_MS = 10000;
  /* (revue lot 23) l'aperçu en préparation répond 202 (lot 21) : redemandé, de plus en plus tard, borné. */
  var REPRISE_APERCU_MS = 2000;
  var REPRISES_APERCU = 8;
  /* (revue) plus aucune annonce depuis SILENCE_MS pendant l'attente (galerie muette, suivi arrêté après 30 min de
     regard) : le bouton revient. Pendant une vraie attente, le bandeau annonce toutes les 5 s. */
  var SILENCE_MS = 60000;
  var silence = null;
  var html = document.documentElement;
  var choixLu = false;

  liens.forEach(function (a) {
    a.setAttribute("data-tms-histoire-chat", a.getAttribute("href"));
  });

  function remplacer(modele, valeurs) {
    return String(modele || "").replace(/%(\w+)%/g, function (m, k) {
      return k in valeurs ? valeurs[k] : m;
    });
  }

  /* ── Le lien : le chat, ou la connexion qui y revient ─────────────────────────────────────────── */
  function peindreLiens(connecte) {
    liens.forEach(function (a) {
      var chat = a.getAttribute("data-tms-histoire-chat");
      if (connecte || !connexion) {
        a.setAttribute("href", chat);
        return;
      }
      a.setAttribute("href", connexion + (connexion.indexOf("?") === -1 ? "?" : "&") + "retour=" + encodeURIComponent(chat));
    });
  }

  /* ── L'image : l'exemple, puis SA famille ─────────────────────────────────────────────────────── */
  function varianteDe(fam) {
    var vs = (fam && fam.variantes) || [];
    var voulue = racine && racine.dataset.gabarit;
    return vs.filter(function (x) {
      return x && x.apercu && x.cle === voulue;
    })[0] || vs.filter(function (x) {
      return x && x.apercu;
    })[0] || null;
  }

  /* 🔴 LOT 22 comptes : LE COMPOSITEUR DU SERVICE (`pose.js`), chargé une fois par page — la balise est partagée avec les
     autres scripts du thème ; le bloc en charge peut-être une autre, `pose.js` ne s'installe qu'une fois. Il ne vient
     pas (réseau, service ancien, 8 s) : `null`, et l'image du serveur s'affiche. */
  function avecPose(base) {
    if (window.TmsPose) return Promise.resolve(window.TmsPose);
    return new Promise(function (ok) {
      var fini = false;
      function fin() { if (!fini) { fini = true; ok(window.TmsPose || null); } }
      function finie() { s.setAttribute("data-tms-pose-fini", ""); }
      var s = document.querySelector("script[data-tms-pose-js]");
      /* (revue du lot 22) une balise déjà FINIE (chargée ou tombée) ne rappellera plus personne : sans `TmsPose`,
         l'image du serveur tout de suite, pas après 8 s. Les trois chargeurs (bloc, compte, histoire) la partagent. */
      if (s && s.hasAttribute("data-tms-pose-fini")) return fin();
      if (!s) {
        s = document.createElement("script");
        s.src = base + "/pose.js";
        s.async = true;
        s.setAttribute("data-tms-pose-js", "");
        s.addEventListener("load", finie);
        s.addEventListener("error", finie);
        (document.head || document.documentElement).appendChild(s);
      }
      s.addEventListener("load", fin);
      s.addEventListener("error", fin);
      window.setTimeout(fin, 8000);
    });
  }

  /* L'image de SA famille : composée par le navigateur quand le service sert sa pose (`TmsPose.montrer` émet `load`
     quand elle est à l'écran), sinon l'image du serveur — avec les mêmes `onload` / `onerror`. */
  function montrerFamille(img, base, src, pose, o) {
    if (!pose) {
      if (window.TmsPose) window.TmsPose.retirer(img);  /* la composition d'avant ne reste pas par-dessus */
      img.src = src;
      return;
    }
    avecPose(base).then(function (tp) {
      if (!tp || !tp.montrer) img.src = src;
      else tp.montrer(img, Object.assign({ service: base, jpeg: src, pose: pose }, o || {}));
    });
  }


  function poserEtat(valeur) {
    if (valeur) html.setAttribute("data-tms-histoire-etat", valeur);
    else html.removeAttribute("data-tms-histoire-etat");
  }

  function veiller() {
    window.clearTimeout(silence);
    silence = window.setTimeout(function () {
      if (html.getAttribute("data-tms-histoire-etat") !== "attente") return;
      if (document.hidden) return veiller(); /* onglet caché : le bandeau se tait, il reprendra au retour */
      poserEtat(null);
    }, SILENCE_MS);
  }

  /* (revue) la famille DE L'APPAREIL seulement, même ordre que le bandeau : l'onglet, puis l'appareil. */
  function jetonDeLAppareil() {
    try {
      return window.sessionStorage.getItem("tms_jeton") || window.localStorage.getItem("tms_ma_famille");
    } catch (e) {
      return null;
    }
  }

  function recevoirFamille(fam) {
    if (!fam) return;
    var attente = fam.etat === "en_cours" || fam.etat === "indisponible";
    poserEtat(attente ? "attente" : null);
    if (attente) veiller();
    if (!racine || !service || fam.etat !== "prête") return;
    var v = varianteDe(fam);
    var img = racine.querySelector("[data-tms-histoire-famille]");
    var exemple = racine.querySelector("[data-tms-histoire-exemple]");
    if (!v || !img) return;
    var src = service + v.apercu;
    if (img.getAttribute("src") === src || img.getAttribute("data-tms-montre") === src || img.tmsVoulue === src) return;
    img.tmsVoulue = src;
    var reprises = 0;
    img.onload = function () {
      img.hidden = false;
      if (exemple) exemple.hidden = true;
      racine.setAttribute("data-etat", "famille");
    };
    img.onerror = function () {
      /* l'exemple reste : une image manquante n'est pas une famille perdue */
      img.hidden = true;
      if (exemple) exemple.hidden = false;
      /* (revue lot 23) un 202 (aperçu en préparation) arrive ici comme une erreur : SA famille est redemandée */
      if (reprises >= REPRISES_APERCU) return;
      reprises += 1;
      window.setTimeout(function () {
        if (img.tmsVoulue !== src) return;
        img.src = src + (src.indexOf("?") < 0 ? "?" : "&") + "reprise=" + reprises;
      }, REPRISE_APERCU_MS * reprises);
    };
    montrerFamille(img, service, src, v.pose, { maquette: true });
  }

  document.addEventListener("tms:famille", function (ev) {
    var d = ev.detail || {};
    /* 🔴 (revue) une page qui ouvre une AUTRE famille (le bloc de « My family ») l'annonce aussi : elle ne décide ni du
       bouton ni de l'image. Le bandeau, lui, suit toujours la famille de l'appareil. */
    if (d.source !== "bandeau" && d.jeton !== jetonDeLAppareil()) return;
    recevoirFamille(d.famille);
  });
  if (bandeau && bandeau.tmsDerniere) recevoirFamille(bandeau.tmsDerniere.famille);
  function attendreAnnonce() {
    window.setTimeout(function () {
      if (html.getAttribute("data-tms-histoire-etat") === "inconnu") poserEtat(null);
    }, ATTENTE_MAX_MS);
  }
  attendreAnnonce();
  /* Une famille du compte adoptée en cours de page (tms-compte.js) : le bandeau va l'annoncer, le bouton l'attend. */
  document.addEventListener("tms:memoire", function () {
    if (html.hasAttribute("data-tms-histoire-etat")) return;
    poserEtat("inconnu");
    attendreAnnonce();
  });

  /* ── D4 : le choix de famille ─────────────────────────────────────────────────────────────────── */
  function noms(f) {
    return (f.membres || []).map(function (m) {
      return (m && m.name ? String(m.name) : "").trim();
    }).filter(Boolean).join(", ");
  }

  function effectif(f) {
    var n = (f.membres || []).length;
    return n === 1 ? t.tPersonne : remplacer(t.tPersonnes, { N: String(n) });
  }

  function carte(f, choisir) {
    var li = document.createElement("li");
    li.className = "histoire__famille";
    li.setAttribute("data-tms-histoire-carte", "");
    li.setAttribute("data-id", f.id);
    var ul = document.createElement("ul");
    ul.className = "histoire__portraits";
    ul.setAttribute("aria-hidden", "true");
    (f.membres || []).slice(0, MAX_PORTRAITS).forEach(function (m) {
      /* 🔴 (revue) LE PORTRAIT DE BASE D'ABORD : l'API signe `…Medium` sans vérifier qu'elle existe (même choix que la
         carte héros du chat) ; `…Medium` ne sert qu'à défaut. */
      var src = m && (m.illustrationStoragePath || m.illustrationStoragePathMedium);
      if (!src) return;
      var p = document.createElement("li");
      var img = document.createElement("img");
      img.alt = "";
      img.width = 48;
      img.height = 48;
      img.src = src;
      p.appendChild(img);
      ul.appendChild(p);
    });
    var qui = document.createElement("p");
    qui.className = "histoire__qui";
    qui.textContent = noms(f) || effectif(f);
    var sous = document.createElement("span");
    sous.textContent = f.courante ? effectif(f) + " · " + t.tCourante : effectif(f);
    qui.appendChild(sous);
    var b = document.createElement("button");
    b.type = "button";
    b.className = "btn btn-petit btn-2";
    b.textContent = t.tGarder;
    b.setAttribute("aria-label", remplacer(t.tGarderLabel, { NOMS: noms(f) || effectif(f) }));
    b.addEventListener("click", function () {
      choisir(f.id);
    });
    li.appendChild(ul);
    li.appendChild(qui);
    li.appendChild(b);
    return li;
  }

  function peindreChoix(etat) {
    var zone = racine && racine.querySelector("[data-tms-histoire-choix]");
    var liste = zone && zone.querySelector("[data-tms-histoire-familles]");
    var message = zone && zone.querySelector("[data-tms-histoire-message]");
    if (!liste || !etat || etat.a_trancher !== true || !Array.isArray(etat.familles) || etat.familles.length < 2) return;
    liste.textContent = "";
    var choisir = function (id) {
      var boutons = liste.querySelectorAll("button");
      boutons.forEach(function (x) {
        x.disabled = true;
      });
      message.textContent = "";
      fetch(api + "/v1/families/me/choix", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: id }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error("choix " + r.status);
          liste.querySelectorAll("[data-tms-histoire-carte]").forEach(function (li) {
            if (li.getAttribute("data-id") !== id) li.remove();
            else li.querySelectorAll("button").forEach(function (x) {
              x.remove();
            });
          });
          message.textContent = t.tFait;
          /* le bouton pressé vient de disparaître : le focus va à la phrase qui dit ce qui s'est passé */
          message.setAttribute("tabindex", "-1");
          message.focus();
        })
        .catch(function () {
          boutons.forEach(function (x) {
            x.disabled = false;
          });
          message.textContent = t.tErreur;
        });
    };
    etat.familles.forEach(function (f) {
      if (f && f.id) liste.appendChild(carte(f, choisir));
    });
    zone.hidden = liste.children.length < 2;
  }

  function lireChoix() {
    if (choixLu || !racine || !api) return;
    choixLu = true;
    fetch(api + "/v1/families/me/choix", { credentials: "include" })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(peindreChoix)
      .catch(function () {
        /* panne : le choix n'est qu'une proposition, rien ne s'affiche */
      });
  }

  function recevoirSession(connecte) {
    peindreLiens(connecte);
    if (connecte) return lireChoix();
    /* (revue) déconnecté : les familles du compte quittent l'écran ; une prochaine connexion relira le choix. */
    choixLu = false;
    var zone = racine && racine.querySelector("[data-tms-histoire-choix]");
    if (zone) {
      zone.hidden = true;
      var liste = zone.querySelector("[data-tms-histoire-familles]");
      if (liste) liste.textContent = "";
    }
  }

  document.addEventListener("tms:session", function (ev) {
    recevoirSession(!!(ev.detail && ev.detail.connecte));
  });
  var dejaSu = document.documentElement.getAttribute("data-tms-session");
  if (dejaSu) recevoirSession(dejaSu === "connecte");
})();
